import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ORIGIN = "https://app.stockmusic.ro";
const DEFAULT_IMAGE = `${ORIGIN}/brand/stockmusic-app-logo-clean.png`;

const PUBLIC_ROUTES = {
  "/": {
    title: "StockMusic.ro | Muzică ambientală licențiată pentru afaceri",
    description:
      "Licențiază și redă muzică ambientală pentru restaurante, hoteluri, magazine, saloane și alte spații comerciale. Contract, factură și licență online.",
  },
  "/music": {
    title: "Bibliotecă de muzică ambientală pentru afaceri | StockMusic.ro",
    description:
      "Explorează biblioteca StockMusic.ro cu muzică ambientală pentru restaurante, hoteluri, magazine și alte spații comerciale.",
  },
  "/legal/terms": {
    title: "Termeni și condiții | StockMusic.ro",
    description: "Termenii și condițiile de utilizare a platformei și serviciilor StockMusic.ro.",
  },
  "/legal/privacy": {
    title: "Politica de confidențialitate | StockMusic.ro",
    description: "Politica StockMusic.ro privind confidențialitatea și prelucrarea datelor personale.",
  },
  "/legal/gdpr": {
    title: "Politica GDPR | StockMusic.ro",
    description: "Informații despre prelucrarea datelor personale în platforma StockMusic.ro.",
  },
};

function upsertMeta(selector, attributes) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement("meta");
    document.head.appendChild(element);
  }
  Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value));
}

function upsertCanonical(href) {
  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", href);
}

export default function Seo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const route = PUBLIC_ROUTES[pathname];
    const isPublic = Boolean(route);
    const title = route?.title || "Cont StockMusic.ro";
    const description =
      route?.description || "Zonă securizată pentru administrarea contului, licențelor și documentelor StockMusic.ro.";
    const canonicalPath = pathname === "/legal/gdpr" ? "/legal/privacy" : pathname;
    const canonical = `${ORIGIN}${canonicalPath === "/" ? "/" : canonicalPath}`;

    document.title = title;
    document.documentElement.lang = "ro";

    upsertMeta('meta[name="description"]', { name: "description", content: description });
    upsertMeta('meta[name="robots"]', {
      name: "robots",
      content: isPublic ? "index, follow, max-image-preview:large" : "noindex, nofollow, noarchive",
    });
    upsertMeta('meta[property="og:title"]', { property: "og:title", content: title });
    upsertMeta('meta[property="og:description"]', { property: "og:description", content: description });
    upsertMeta('meta[property="og:url"]', { property: "og:url", content: canonical });
    upsertMeta('meta[property="og:image"]', { property: "og:image", content: DEFAULT_IMAGE });
    upsertMeta('meta[name="twitter:title"]', { name: "twitter:title", content: title });
    upsertMeta('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    upsertMeta('meta[name="twitter:image"]', { name: "twitter:image", content: DEFAULT_IMAGE });
    upsertCanonical(canonical);
  }, [pathname]);

  return null;
}
